export default __webpack_public_path__ + "static/media/client14.f43cf7c5.jpeg";